import React from 'react'

const SongwriterCatalogHeader = () => (
    <>
        <p>
            Your catalog shows songs associated with your writer name(s) that you have added. Here, you can search to
            find specific songs, view details about specific songs, or export your entire catalog.
        </p>
        <br />
        <p>
            To search for specific song(s) within your catalog, select criteria from the Song Title and/or Co-Writer
            fields. To refine your search, click the drop-down arrow to select other search criteria. If you need more
            details about a song, click on the song to be taken to its Details page.
        </p>
        <br />
        <p>
            To export all the songs in your catalog in one file, click the <strong>Export</strong> button.
        </p>
    </>
)

export default SongwriterCatalogHeader
